import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { NbRegisterComponent, NbAuthResult, NbAuthService, NB_AUTH_OPTIONS } from '@nebular/auth';
import { Router } from '@angular/router';

@Component({
    selector: 'ngx-register',
    templateUrl: './register.component.html',
})
export class RegisterComponent extends NbRegisterComponent {

    constructor(
        protected service: NbAuthService,
        @Inject(NB_AUTH_OPTIONS) protected options = {},
        protected cd: ChangeDetectorRef,
        protected router: Router
    ) {
        super(service, options, cd, router);
    }

    register(): void {
        this.errors = this.messages = [];
        this.submitted = true;

        this.service.register(this.strategy, this.user).subscribe((result: NbAuthResult) => {

            let response = result.getResponse();
            if (response.error)
                result = new NbAuthResult(false, response, false, response.error.Error);

            this.submitted = false;
            if (result.isSuccess()) {
                this.messages = result.getMessages();
            } else {
                this.errors = result.getErrors();
            }

            const redirect = result.getRedirect();
            if (redirect) {
                setTimeout(() => {
                    return this.router.navigateByUrl(redirect);
                }, this.redirectDelay);
            }
            this.cd.detectChanges();
        });
    }
}